module.exports = __webpack_public_path__ + "img/history_white.8dd19df2.svg";